import { render } from "./Single.vue?vue&type=template&id=811988ca"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Single.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "811988ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('811988ca', __exports__)) {
    api.reload('811988ca', __exports__)
  }
  
  module.hot.accept("./Single.vue?vue&type=template&id=811988ca", () => {
    api.rerender('811988ca', render)
  })

}


export default __exports__